import { render, staticRenderFns } from "./ReservationInfo.vue?vue&type=template&id=6387c08e&scoped=true&"
import script from "./ReservationInfo.vue?vue&type=script&lang=js&"
export * from "./ReservationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReservationInfo.vue?vue&type=style&index=0&id=6387c08e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6387c08e",
  null
  
)

export default component.exports